"use strict";

exports.__esModule = true;
exports.ThresholdPicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _polished = require("polished");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _compareThresholds = require("../compareThresholds");
var _ColorPicker = require("../../../Form/ColorPicker");
var _ThresholdGradientPreview = require("./ThresholdGradientPreview");
var _excluded = ["value", "min", "max", "usePopover", "onChange", "gradientProps"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ThresholdPickerContainer = _styledComponents["default"].div.withConfig({
  displayName: "ThresholdPicker__ThresholdPickerContainer",
  componentId: "sc-138poed-0"
})(["display:flex;flex-direction:column;"]);
var ThresholdItem = _styledComponents["default"].div.withConfig({
  displayName: "ThresholdPicker__ThresholdItem",
  componentId: "sc-138poed-1"
})(["display:flex;flex:1;margin-top:0.25rem;"]);

/**
 * Allows the user to associate colors with threshold values.
 */
var ThresholdPicker = exports.ThresholdPicker = /*#__PURE__*/function (_Component) {
  function ThresholdPicker() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.createThresholdGradients = function (thresholds) {
      var background = "transparent";
      if (thresholds.length === 1) {
        background = thresholds[0][1];
      } else if (thresholds.length > 1) {
        var linearGradient = thresholds.map(function (_ref) {
          var value = _ref[0],
            color = _ref[1];
          return color + " " + value + "%";
        }).join(",");
        background = "linear-gradient(to right, " + linearGradient + ")";
      }
      return background;
    };
    return _this;
  }
  _inheritsLoose(ThresholdPicker, _Component);
  var _proto = ThresholdPicker.prototype;
  _proto.createValueChangeHandler = function createValueChangeHandler(index) {
    var _this2 = this;
    return function (value) {
      var _this2$props = _this2.props,
        thresholds = _this2$props.value,
        onChange = _this2$props.onChange;
      var color = thresholds[index][1];
      var updated = thresholds.slice();
      updated[index] = [Number(value), color];
      onChange(updated);
    };
  };
  _proto.createColorChangeHandler = function createColorChangeHandler(index) {
    var _this3 = this;
    return function (color) {
      var _this3$props = _this3.props,
        thresholds = _this3$props.value,
        onChange = _this3$props.onChange;
      if (color !== undefined) {
        var value = thresholds[index][0];
        var updated = thresholds.slice();
        updated[index] = [value, color];
        onChange(updated);
      }
    };
  };
  _proto.createAddClickHandler = function createAddClickHandler(index) {
    var _this4 = this;
    return function () {
      var _this4$props = _this4.props,
        original = _this4$props.value,
        max = _this4$props.max,
        onChange = _this4$props.onChange;
      var thresholds = original.slice();
      var predecessor = thresholds[index];
      var isLast = index === thresholds.length - 1;
      var nextValue = isLast ? max : thresholds[index + 1][0];
      var nextColor = isLast ? predecessor[1] : thresholds[index + 1][1];
      var value = Math.round(predecessor[0] + (nextValue - predecessor[0]) / 2);
      thresholds.splice(index + 1, 0, [value, (0, _polished.mix)(0.5, nextColor, predecessor[1])]);
      onChange(thresholds);
    };
  };
  _proto.createRemoveClickHandler = function createRemoveClickHandler(index) {
    var _this5 = this;
    return function () {
      var _this5$props = _this5.props,
        original = _this5$props.value,
        onChange = _this5$props.onChange;
      var thresholds = original.slice();
      thresholds.splice(index, 1);
      onChange(thresholds);
    };
  };
  _proto.render = function render() {
    var _this$props = this.props,
      value = _this$props.value,
      min = _this$props.min,
      max = _this$props.max,
      usePopover = _this$props.usePopover,
      onChange = _this$props.onChange,
      gradientProps = _this$props.gradientProps,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var thresholds = value.slice().sort(_compareThresholds.compareThresholds);
    var body = [];
    var prev = min;
    for (var i = 0; i < thresholds.length; i++) {
      var threshold = thresholds[i];
      var isLast = i === thresholds.length - 1;
      var key = String(i);
      var next = isLast ? max : thresholds[i + 1][0];
      body.push(/*#__PURE__*/_react["default"].createElement(ThresholdItem, {
        key: key
      }, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
        minimal: true
      }, /*#__PURE__*/_react["default"].createElement(_core.Popover, {
        minimal: true,
        content: /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            padding: "1.2rem",
            paddingRight: 0
          }
        }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
          labelRenderer: false,
          showTrackFill: false,
          value: threshold[0],
          min: prev,
          max: next,
          onChange: this.createValueChangeHandler(i),
          vertical: true
        }))
      }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
        text: threshold[0] + "%",
        style: {
          width: 128
        }
      })), /*#__PURE__*/_react["default"].createElement(_ColorPicker.ColorPicker, {
        value: threshold[1],
        onChange: this.createColorChangeHandler(i)
      }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
        icon: _icons.IconNames.ADD,
        disabled: threshold[0] === max,
        onClick: this.createAddClickHandler(i)
      }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
        icon: _icons.IconNames.REMOVE,
        disabled: thresholds.length < 3,
        onClick: this.createRemoveClickHandler(i)
      }))));
      prev = threshold[0];
    }
    if (usePopover) {
      return /*#__PURE__*/_react["default"].createElement(_core.Popover, {
        minimal: true,
        content: /*#__PURE__*/_react["default"].createElement(ThresholdPickerContainer, extra, body)
      }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
        minimal: true,
        style: {
          padding: 0,
          background: this.createThresholdGradients(thresholds)
        }
      }));
    }
    return /*#__PURE__*/_react["default"].createElement(ThresholdPickerContainer, extra, /*#__PURE__*/_react["default"].createElement(_ThresholdGradientPreview.ThresholdGradientPreview, _extends({}, gradientProps, {
      thresholds: thresholds
    })), body);
  };
  return ThresholdPicker;
}(_react.Component);
ThresholdPicker.defaultProps = {
  gradientProps: {
    style: {
      width: 256,
      height: 64
    }
  },
  usePopover: false,
  value: [],
  min: 0,
  max: 100
};